export const CLIENT_PICKER_PATH = "/client";
export const CLIENT_DASHBOARD_PATH = "/client/dashboards/home";

/**
 * Post-auth destination for client users.
 * Single-client accounts skip the /client picker; multi-client accounts land there.
 */
export function getClientLandingPath(user) {
  const mappingCount = Number(user?.client_mapping_count);

  if (mappingCount > 1) {
    return CLIENT_PICKER_PATH;
  }

  if (user?.client_id) {
    return CLIENT_DASHBOARD_PATH;
  }

  return CLIENT_PICKER_PATH;
}
